
jQuery( document ).ready(function() {
    jQuery('.readmore__content').each(function () {
        jQuery(this).click(function () {
            console.log('click', this);
            jQuery(this).closest('.read-more-container').find('.read-open').toggle();
            //let getText = jQuery(this).html();

            // jQuery(this).html(function(i, text){
            //   return text === "&gt;&gt;&gt; weiterlesen" ? "weniger anzeigen" : "&gt;&gt;&gt; weiterlesen";
            // });


            jQuery(this).closest('.read-more-container').find('.show-more-container').slideToggle();
        });
    });
});